// extracted by mini-css-extract-plugin
export default {"grid":"ListProducts_grid__tPfOe"};